import React from "react";
import { motion } from "framer-motion";
import { PRODUCT_IMAGE, scrollToOffer } from "../data/constants";
import { BuyButton } from "./BuyButton";
const BADGES = ["📄 100% PDF", "⚡️ Entrega Inmediata", "📚 6 Módulos + 6 Bonos"];
export function Hero() {
  return <header className="w-full bg-beige px-5 pt-10 pb-8" data-id="element-85" data-mp="4lqictyan92g">
      <div className="mx-auto max-w-md text-center" data-id="element-86" data-mp="4n1oh0f7oswq">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mx-auto max-w-[360px] font-serif text-[23px] font-bold leading-[1.08] tracking-tight text-deep-green sm:max-w-md sm:text-[26px]" data-id="element-87" data-mp="1297a3xzwwp6o">
          Obtené Tu Ciudadanía Italiana Sin Perder Meses Entre Información Contradictoria
        </motion.h1>

        <motion.button type="button" onClick={scrollToOffer} initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="mt-6 block w-full overflow-hidden rounded-3xl border border-sand bg-cream shadow-lg" aria-label="Ver la oferta del producto" data-id="element-88" data-mp="3d21uq4bdkwqw">
          <img src={PRODUCT_IMAGE} alt="Kit Ciudadanía Italiana Resuelta: la guía completa paso a paso con 6 tomos y 6 bonos" className="h-auto w-full" data-id="element-89" data-mp="39aurxfl1nqya" />
        </motion.button>

        <p className="mt-6 text-[15px] leading-relaxed text-ink/80" data-id="element-90" data-mp="30gztsricb0s5">
          Aprendé a evaluar tu caso, reunir la documentación correcta y preparar
          tu expediente con un sistema claro de 6 tomos, herramientas prácticas y
          un plan paso a paso para avanzar con mayor organización.
        </p>

        <div className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-91" data-mp="2vjg670zr5bnj">
          {BADGES.map(b => <span key={b} className="rounded-full border border-sand bg-cream px-3 py-1.5 text-xs font-semibold text-italian-green" data-id="element-92" data-mp="2hjowhcg9qhfc">
              {b}
            </span>)}
        </div>

        <div className="mt-6" data-id="element-93" data-mp="nbbc4wdi0748">
          <BuyButton data-id="element-94" data-mp="nb1jf112jluu" />
        </div>
      </div>
    </header>;
}